import { createCountryRequest } from "../../data/countryApi";
import { validateCountryPayload } from "../validator/validateCountryPayload";

export async function createCountryUseCase(payload) {
  const error = validateCountryPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createCountryRequest(payload);
}
